module.exports = __webpack_public_path__ + "img/diamondjewelry-mobile@2x.546d6fd.jpg";